<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useColorModes } from '@coreui/vue-pro'
import { useThemeStore } from '@/store/theme.ts'

// Stessa chiave letta dallo script inline di index.html, che applica il tema
// scuro prima del montaggio dell'app (niente lampo bianco al caricamento).
const { isColorModeSet, setColorMode } = useColorModes('csbsnc-theme')

const currentTheme = useThemeStore()

onBeforeMount(() => {
  const urlParams = new URLSearchParams(window.location.search)
  const theme = urlParams.get('theme')?.match(/^(light|dark|auto)$/)?.[0]

  if (theme) {
    setColorMode(theme)
    return
  }

  if (isColorModeSet()) {
    return
  }

  setColorMode(currentTheme.theme)
})
</script>

<template>
  <router-view />
</template>

<style lang="scss">
@use '@/styles/style';
</style>
